<template>
  <div>
    <div class="btn-group btn-group-horizontal btn-group-toggle col text-center" role="group">
      <label
        v-for="index in buttonCount"
        :key="index"
        class="btn btn-questionnaire btn-questionnaire-horizontal btn-iphone text-center py-4"
        :class="currentOption === index ? 'btn-primary' : 'btn-outline-primary'"
      >
        <span class="mr-2">
          {{ index }}
        </span>
        <input
          type="radio"
          class="text-center"
          name="scale-options"
          v-model="currentOption"
          :value="index"
        >
      </label>
    </div>
    <div class="d-flex justify-content-between col mt-3 text-md btn-group-horizontal">
      <span>Stämmer aldrig</span>
      <span>Stämmer alltid</span>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      currentOption: null,
      buttonCount: 5
    }
  }
}
</script>

<style>
</style>
